<template>
  <el-main class="el-main-wrapper">
    <router-view></router-view>
  </el-main>
</template>
<script>
export default {
  name: 'layout-main'
}
</script>
<style lang="stylus">
.el-main-wrapper {
  background: #f9f9f9;
  overflow: auto;
  padding: 0 0 10px;
}
</style>
